import { EuiHeader, EuiText, EuiKeyPadMenu, EuiSelect } from "@elastic/eui";
import styled from "styled-components";

export const Logo = styled.img`
    width: 29px;
    height: auto;
    margin: 10px;
`;

export const StyledHeader = styled(EuiHeader)`
    .euiHeaderSectionItem:after {
        top: 0 !important;
    }

    .brand-name {
        line-height: 48px;
        /* font-weight: 900; */
        font-size: 16px;
        font-weight: 300;
        margin-right: 76px;
    }
`;

export const HeaderContent = styled.div`
    display: flex;
    max-width: 1660px;
    width: 100%;
    margin: 0 auto;
    flex-direction: row;
    justify-content: flex-start;
`;

export const StyledText = styled(EuiText)`
    @media (max-width: 768px) {
        .brand-name {
            margin-right: 0px;
            font-size: 12px;
        }
    }
`;

export const StyledPadMenu = styled(EuiKeyPadMenu)`
    @media (max-width: 768px){
        width:200px !important;
    }
    i.icon.icon-en-to-ar,
    i.icon.icon-ar-to-en {
        font-size: 1.5rem;
    }
}
`;

export const StyledSelect = styled(EuiSelect)`
    option[value="en"] {
        background: url("https://cdn.britannica.com/33/4833-004-828A9A84/Flag-United-States-of-America.jpg")
            no-repeat;
        background-size: 25px 25px;
    }
`;
